import type { FormatDistanceFn, FormatDistanceToken } from 'date-fns';
import { formatDuration, intervalToDuration } from 'date-fns';

const formatDistanceLocale: Record<string, string> = {
  xHours: '{{count}}h',
  xMinutes: '{{count}}min',
};

const formatDistance: FormatDistanceFn = (
  token: FormatDistanceToken,
  count: number,
) => {
  if (token === 'xHours' || token === 'xMinutes') {
    return formatDistanceLocale[token].replace('{{count}}', `${count}`);
  }
  return `${count}`;
};

const shortEnLocale = {
  formatDistance,
};

export const formatPodcastDuration = (duration: number) => {
  if (!duration) return;
  const durations = intervalToDuration({ start: 0, end: duration * 60 * 1000 });
  return formatDuration(durations, {
    format: ['hours', 'minutes'],
    delimiter: ' ',
    locale: shortEnLocale,
  });
};
